// components
import CommonForm from "./CommonForm";
import BaseApi from "../../utils/BaseApi";
import {setArrayKey, splitToList} from "../../utils/misc";
import CommonActionModal from "./CommonActionModal";

// icons
import EditIcon from '@mui/icons-material/Edit';


class CommonEditModal extends CommonActionModal {
    async componentDidMount() {
        let permission;
        if (typeof this.props.permission === 'function'){
            permission = this.props.permission();
        }
        else {
            permission = this.props.permission
        }
        this.setState({
            button: {
                icon: EditIcon,
                label: null,
                iconOnly: this.props.buttonIconOnly,
                color: 'default',
            },
            ready: true,
            permission: permission?permission:true,
            deniedPermissionComponent: this.props.deniedPermissionComponent,
            flat: this.props.flat,
            width: '80vw',
        })
    }

    async beforeModalOpen(){
        let formFields = await this.retrieveFields()
        return {
            formFields: formFields,
            modalLabel: '',
            modalIcon: null,
            mainComponent: CommonForm,
            mainComponentProps: {
                fields: formFields,
                processForm: this.processForm.bind(this),
                object: this.props.obj,
            },
        }
    }

    async retrieveFields() {
        const url = `${this.props.baseUrl}/update_form/`;
        const api = new BaseApi();
        const params = {
            fields: JSON.stringify(
                this.props.m2mFields?
                    this.props.fields.concat(this.props.m2mFields):
                    this.props.fields
            )
        }
        let response = await api.get(
            url,
            params
        );
        let formFields = response.data;
        if (this.props.fieldUpdates){
            for (let field of this.props.fieldUpdates){
                for (let update of field.updates){
                    formFields = setArrayKey(
                        formFields,
                        'name',
                        field.name,
                        update.key,
                        update.value,
                    )
                }
            }
        }
        return formFields
    }

    async processForm(form) {
        let formDataObj = Object.fromEntries(
            form.state.formData.entries()
        );

        // if (this.props.m2mFields){
        //     for (const key in formDataObj) {
        //         if (this.props.m2mFields.indexOf(key) > -1){
        //             formDataObj[key] = splitToList(formDataObj[key], ',')
        //         }
        //     }
        // }
        console.log(this.state.formFields)
        let uploadFormData = new FormData()

        for (let field of this.state.formFields){
            switch (field.type){
                case 'number':
                    formDataObj[field.name] = Number(formDataObj[field.name])
                    break
                case 'multiselect':
                    if (field.name in formDataObj) {
                        formDataObj[field.name] = splitToList(formDataObj[field.name], ',')
                    }
                    break
                case 'file':
                    delete formDataObj[field.name]
                    let fileInput = form.state.formObject[field.name];
                    let upload = fileInput.files[0];
                    if (upload) {
                        uploadFormData.append(field.name, upload);
                    }
                    delete formDataObj[field.name]
                    break
                case 'json':
                    if (field.name in formDataObj) {
                        formDataObj[field.name] = JSON.parse(formDataObj[field.name])
                    }
                    break
                default:
                    break
            }
        }

        const url = `${this.props.baseUrl}/${this.props.obj.id}/`;
        const api = new BaseApi();
        let response = await api.patch(
            url,
            formDataObj
        );
        if (response.status === 200 ){
            let _response = await api.patch(
                url,
                uploadFormData
            );
            if (_response.status === 200) {
                if (typeof this.props.callBack == 'function') {
                    await this.props.callBack(response.data);
                }
                this.setModalOpenFalse();
            }
        }
        return response
    }
}

export default CommonEditModal
